// The route a pane renders. Under an overlay (Settings' window, the Inbox
// sheet) the shell keeps rendering the last pane route, but $route and
// useRoute() inside the pane would still answer the overlay's route: a
// page under Settings would read /settings/... and lose its own params.
// So panes never read $route or useRoute(); they read this
// (tests/w1-paneRoute.test.mjs enforces it).
//
//   Composition API: const route = usePaneRoute(); route.value.params
//   Options API:     mixins: [paneRouteMixin], then this.paneRoute
//
// It injects vue-router's routerViewLocationKey, which <router-view
// :route> provides to the component it renders. Outside a router-view (an
// overlay host) it answers the real current route.
import { computed, inject, unref } from "vue";
import { routerViewLocationKey, useRoute } from "vue-router";

export function usePaneRoute() {
  const injected = inject(routerViewLocationKey, null);
  if (injected) return computed(() => injected.value);
  const route = useRoute();
  return computed(() => route);
}

// The pane route from inside a component that uses paneRouteMixin, usable
// in data() too (injections resolve before data; computeds after).
// (Vue unwraps an injected ref in the Options API; unref covers both.)
export function paneRouteOf(vm) {
  const injected = vm ? unref(vm.paneRouteInjected) : null;
  return injected || vm.$router.currentRoute.value;
}

export const paneRouteMixin = {
  inject: {
    paneRouteInjected: { from: routerViewLocationKey, default: null },
  },
  computed: {
    paneRoute() {
      return paneRouteOf(this);
    },
  },
};
